function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { axios } from '@repo/http';
import { useQuery } from '@tanstack/react-query';
import { GET_ORG_TEAM_LIST_PATH, get_org_team_list_path } from 'ze-api-contract/organization-v2/get-organization-team-list';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export const orgTeamList = createQueryKeys('organization', {
    teamList: (param)=>{
        let { organization, queryParams } = param;
        return {
            queryKey: [
                GET_ORG_TEAM_LIST_PATH,
                organization,
                _object_spread({}, queryParams)
            ],
            queryFn: async ()=>{
                if (!organization) {
                    return;
                }
                return axios.get(get_org_team_list_path({
                    organization
                }), {
                    params: queryParams
                }).then((res)=>res.data.entities);
            }
        };
    }
});
/**
 * Get specific organization team list.
 *
 * @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md
 */ export function useOrganizationTeamList(param) {
    let { organization, queryParams } = param;
    const { isLoading, data: teamList, error } = useQuery(orgTeamList.teamList({
        organization,
        queryParams
    }));
    return {
        teamList,
        isLoading,
        error
    };
}
